var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseQtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.86 20.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9fa1a4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.43,0A10.43,10.43,0,1,0,20.86,10.43,10.43,10.43,0,0,0,10.43,0Zm5.74,10.88H4.69a.63.63,0,0,1,0-1.25H16.17a.63.63,0,1,1,0,1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseQtt);
export default __webpack_public_path__ + "static/media/decrease-qtt.e5e63e1384375ebf0ea591ba922e210c.svg";
export { ForwardRef as ReactComponent };